import React, { useState } from 'react';
import { AlertTriangle, Plus, Search, Filter, Camera, CheckCircle2, ArrowLeftRight, Trash2, RotateCcw, DollarSign, X, Calendar, MapPin, Package } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function Adjustments() {
  const [showAddModal, setShowAddModal] = useState(false);
  const [showTransferModal, setShowTransferModal] = useState(false);
  const [adjustmentData, setAdjustmentData] = useState({
    item: '',
    location: 'Walk In',
    type: 'Waste',
    qty: 0,
    reason: '',
    date: new Date().toISOString().split('T')[0]
  });
  const [transferData, setTransferData] = useState({
    item: '',
    fromLocation: 'Walk In',
    toLocation: 'Prep Station',
    qty: 0,
    reason: '',
    date: new Date().toISOString().split('T')[0]
  });
  return <div className="space-y-6" data-id="element-306">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-307">
        <div className="bg-white p-6 rounded-2xl border border-slate-100 shadow-sm" data-id="element-308">
          <p className="text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-1" data-id="element-309">
            Total Adjustments (MTD)
          </p>
          <p className="text-2xl font-black text-rose-600" data-id="element-310">$840.25</p>
          <p className="text-xs text-slate-500 mt-1 font-medium" data-id="element-311">
            1.2% of total COGS
          </p>
        </div>
        <div className="bg-white p-6 rounded-2xl border border-slate-100 shadow-sm" data-id="element-312">
          <p className="text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-1" data-id="element-313">
            MIS PIC Impact
          </p>
          <p className="text-2xl font-black text-slate-900" data-id="element-314">$320.00</p>
          <p className="text-xs text-slate-500 mt-1 font-medium" data-id="element-315">
            4 items affected
          </p>
        </div>
        <div className="bg-white p-6 rounded-2xl border border-slate-100 shadow-sm" data-id="element-316">
          <p className="text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-1" data-id="element-317">
            Waste/Spoilage
          </p>
          <p className="text-2xl font-black text-slate-900" data-id="element-318">$520.25</p>
          <p className="text-xs text-slate-500 mt-1 font-medium" data-id="element-319">
            Trending -5% vs LY
          </p>
        </div>
      </div>

      <div className="flex flex-col md:flex-row md:items-center justify-between gap-4" data-id="element-320">
        <div className="flex items-center gap-4 flex-1 max-w-2xl" data-id="element-321">
          <div className="relative flex-1" data-id="element-322">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" size={16} data-id="element-323" />
            <input type="text" placeholder="Search adjustments..." className="w-full pl-10 pr-4 py-2 bg-white border border-slate-200 rounded-xl text-sm focus:ring-2 focus:ring-emerald-500/20 outline-none transition-all" data-id="element-324" />
          </div>
        </div>
        <div className="flex items-center gap-2" data-id="element-325">
          <button onClick={() => setShowTransferModal(true)} className="flex items-center gap-2 px-4 py-2 bg-white border border-slate-200 rounded-xl text-sm font-bold text-slate-600 hover:bg-slate-50 transition-all shadow-sm" data-id="element-326">
            <ArrowLeftRight size={16} data-id="element-327" />
            Transfer Stock
          </button>
          <button onClick={() => setShowAddModal(true)} className="flex items-center gap-2 px-6 py-2 bg-slate-900 text-white rounded-xl text-sm font-bold hover:bg-slate-800 transition-all shadow-lg shadow-slate-900/20" data-id="element-328">
            <Plus size={16} data-id="element-329" />
            New Adjustment
          </button>
        </div>
      </div>

      <div className="bg-white rounded-2xl border border-slate-100 shadow-sm overflow-hidden" data-id="element-330">
        <div className="overflow-x-auto" data-id="element-331">
          <table className="w-full text-left border-collapse" data-id="element-332">
            <thead data-id="element-333">
              <tr className="bg-slate-50/50 border-b border-slate-100" data-id="element-334">
                <th className="px-6 py-4 text-[10px] font-bold text-slate-400 uppercase tracking-widest" data-id="element-335">
                  Date
                </th>
                <th className="px-6 py-4 text-[10px] font-bold text-slate-400 uppercase tracking-widest" data-id="element-336">
                  Item
                </th>
                <th className="px-6 py-4 text-[10px] font-bold text-slate-400 uppercase tracking-widest" data-id="element-337">
                  Type
                </th>
                <th className="px-6 py-4 text-[10px] font-bold text-slate-400 uppercase tracking-widest text-center" data-id="element-338">
                  Qty
                </th>
                <th className="px-6 py-4 text-[10px] font-bold text-slate-400 uppercase tracking-widest text-right" data-id="element-339">
                  Total $
                </th>
                <th className="px-6 py-4 text-[10px] font-bold text-slate-400 uppercase tracking-widest" data-id="element-340">
                  Status
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-50" data-id="element-341">
              {[1, 2, 3].map(i => <tr key={i} className="hover:bg-slate-50/50 transition-colors" data-id="element-342">
                  <td className="px-6 py-4 text-xs font-bold text-slate-500" data-id="element-343">
                    Jan 12, 2025
                  </td>
                  <td className="px-6 py-4" data-id="element-344">
                    <p className="text-sm font-bold text-slate-900" data-id="element-345">
                      Adjustment Item {i}
                    </p>
                    <p className="text-[10px] text-slate-400 font-medium uppercase tracking-wider" data-id="element-346">
                      Walk In
                    </p>
                  </td>
                  <td className="px-6 py-4" data-id="element-347">
                    <span className="px-2 py-1 bg-amber-50 text-amber-600 text-[10px] font-black rounded uppercase border border-amber-100" data-id="element-348">
                      Damage
                    </span>
                  </td>
                  <td className="px-6 py-4 text-center text-sm font-black text-slate-900" data-id="element-349">
                    2
                  </td>
                  <td className="px-6 py-4 text-right text-sm font-black text-rose-600" data-id="element-350">
                    -$45.00
                  </td>
                  <td className="px-6 py-4" data-id="element-351">
                    <div className="flex items-center gap-1.5" data-id="element-352">
                      <CheckCircle2 size={14} className="text-emerald-500" data-id="element-353" />
                      <span className="text-[10px] font-black text-slate-400 uppercase tracking-wider" data-id="element-354">
                        Approved
                      </span>
                    </div>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>

      {/* New Adjustment Modal */}
      <AnimatePresence data-id="element-355">
        {showAddModal && <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-slate-900/50 backdrop-blur-sm" data-id="element-356">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} className="bg-white rounded-3xl shadow-2xl w-full max-w-2xl overflow-hidden flex flex-col" data-id="element-357">
              <div className="px-8 py-6 border-b border-slate-100 flex items-center justify-between bg-slate-50/50" data-id="element-358">
                <div data-id="element-359">
                  <h3 className="text-xl font-bold text-slate-900" data-id="element-360">
                    New Inventory Adjustment
                  </h3>
                  <p className="text-sm text-slate-500 font-medium" data-id="element-361">
                    Record waste, damage, or manual corrections
                  </p>
                </div>
                <button onClick={() => setShowAddModal(false)} className="p-2 hover:bg-slate-200 rounded-full transition-colors text-slate-400 hover:text-slate-600" data-id="element-362">
                  <X size={20} data-id="element-363" />
                </button>
              </div>

              <div className="p-8 space-y-6" data-id="element-364">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-365">
                  <div className="md:col-span-2" data-id="element-366">
                    <label className="block text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-2" data-id="element-367">
                      Item
                    </label>
                    <div className="relative" data-id="element-368">
                      <Package className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" size={16} data-id="element-369" />
                      <input type="text" placeholder="Search or select item..." className="w-full pl-10 pr-4 py-3 bg-slate-50 border border-slate-200 rounded-xl text-sm focus:ring-2 focus:ring-emerald-500/20 outline-none transition-all" value={adjustmentData.item} onChange={e => setAdjustmentData({
                    ...adjustmentData,
                    item: e.target.value
                  })} data-id="element-370" />
                    </div>
                  </div>

                  <div data-id="element-371">
                    <label className="block text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-2" data-id="element-372">
                      Location
                    </label>
                    <select className="w-full px-4 py-3 bg-slate-50 border border-slate-200 rounded-xl text-sm focus:ring-2 focus:ring-emerald-500/20 outline-none transition-all" value={adjustmentData.location} onChange={e => setAdjustmentData({
                  ...adjustmentData,
                  location: e.target.value
                })} data-id="element-373">
                      <option data-id="element-374">Walk In</option>
                      <option data-id="element-375">Prep Station</option>
                      <option data-id="element-376">Freezer 1</option>
                      <option data-id="element-377">Liquor Room</option>
                    </select>
                  </div>

                  <div data-id="element-378">
                    <label className="block text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-2" data-id="element-379">
                      Adjustment Type
                    </label>
                    <select className="w-full px-4 py-3 bg-slate-50 border border-slate-200 rounded-xl text-sm focus:ring-2 focus:ring-emerald-500/20 outline-none transition-all" value={adjustmentData.type} onChange={e => setAdjustmentData({
                  ...adjustmentData,
                  type: e.target.value
                })} data-id="element-380">
                      <option data-id="element-381">Waste</option>
                      <option data-id="element-382">Damage</option>
                      <option data-id="element-383">MIS PIC</option>
                      <option data-id="element-384">Return</option>
                      <option data-id="element-385">Correction</option>
                    </select>
                  </div>

                  <div data-id="element-386">
                    <label className="block text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-2" data-id="element-387">
                      Quantity (+/-)
                    </label>
                    <input type="number" className="w-full px-4 py-3 bg-slate-50 border border-slate-200 rounded-xl text-sm focus:ring-2 focus:ring-emerald-500/20 outline-none transition-all" value={adjustmentData.qty} onChange={e => setAdjustmentData({
                  ...adjustmentData,
                  qty: Number(e.target.value)
                })} data-id="element-388" />
                  </div>

                  <div data-id="element-389">
                    <label className="block text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-2" data-id="element-390">
                      Date
                    </label>
                    <div className="relative" data-id="element-391">
                      <Calendar className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" size={16} data-id="element-392" />
                      <input type="date" className="w-full pl-10 pr-4 py-3 bg-slate-50 border border-slate-200 rounded-xl text-sm focus:ring-2 focus:ring-emerald-500/20 outline-none transition-all" value={adjustmentData.date} onChange={e => setAdjustmentData({
                    ...adjustmentData,
                    date: e.target.value
                  })} data-id="element-393" />
                    </div>
                  </div>

                  <div className="md:col-span-2" data-id="element-394">
                    <label className="block text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-2" data-id="element-395">
                      Reason / Notes
                    </label>
                    <textarea rows={3} placeholder="Explain why this adjustment is being made..." className="w-full px-4 py-3 bg-slate-50 border border-slate-200 rounded-xl text-sm focus:ring-2 focus:ring-emerald-500/20 outline-none transition-all resize-none" value={adjustmentData.reason} onChange={e => setAdjustmentData({
                  ...adjustmentData,
                  reason: e.target.value
                })} data-id="element-396" />
                  </div>
                </div>
              </div>

              <div className="px-8 py-6 border-t border-slate-100 bg-slate-50/50 flex items-center justify-end gap-3" data-id="element-397">
                <button onClick={() => setShowAddModal(false)} className="px-6 py-2.5 text-sm font-bold text-slate-600 hover:bg-slate-200 rounded-xl transition-all" data-id="element-398">
                  Cancel
                </button>
                <button onClick={() => setShowAddModal(false)} className="px-8 py-2.5 bg-slate-900 text-white rounded-xl text-sm font-bold hover:bg-slate-800 transition-all shadow-lg shadow-slate-900/20" data-id="element-399">
                  Submit Adjustment
                </button>
              </div>
            </motion.div>
          </div>}
      </AnimatePresence>

      {/* Transfer Stock Modal */}
      <AnimatePresence data-id="element-400">
        {showTransferModal && <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-slate-900/50 backdrop-blur-sm" data-id="element-401">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} className="bg-white rounded-3xl shadow-2xl w-full max-w-2xl overflow-hidden flex flex-col" data-id="element-402">
              <div className="px-8 py-6 border-b border-slate-100 flex items-center justify-between bg-slate-50/50" data-id="element-403">
                <div data-id="element-404">
                  <h3 className="text-xl font-bold text-slate-900" data-id="element-405">
                    Transfer Stock
                  </h3>
                  <p className="text-sm text-slate-500 font-medium" data-id="element-406">
                    Move inventory between internal locations
                  </p>
                </div>
                <button onClick={() => setShowTransferModal(false)} className="p-2 hover:bg-slate-200 rounded-full transition-colors text-slate-400 hover:text-slate-600" data-id="element-407">
                  <X size={20} data-id="element-408" />
                </button>
              </div>

              <div className="p-8 space-y-6" data-id="element-409">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-410">
                  <div className="md:col-span-2" data-id="element-411">
                    <label className="block text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-2" data-id="element-412">
                      Item to Transfer
                    </label>
                    <div className="relative" data-id="element-413">
                      <Package className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" size={16} data-id="element-414" />
                      <input type="text" placeholder="Search or select item..." className="w-full pl-10 pr-4 py-3 bg-slate-50 border border-slate-200 rounded-xl text-sm focus:ring-2 focus:ring-emerald-500/20 outline-none transition-all" value={transferData.item} onChange={e => setTransferData({
                    ...transferData,
                    item: e.target.value
                  })} data-id="element-415" />
                    </div>
                  </div>

                  <div data-id="element-416">
                    <label className="block text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-2" data-id="element-417">
                      From Location
                    </label>
                    <div className="relative" data-id="element-418">
                      <MapPin className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" size={16} data-id="element-419" />
                      <select className="w-full pl-10 pr-4 py-3 bg-slate-50 border border-slate-200 rounded-xl text-sm focus:ring-2 focus:ring-emerald-500/20 outline-none transition-all" value={transferData.fromLocation} onChange={e => setTransferData({
                    ...transferData,
                    fromLocation: e.target.value
                  })} data-id="element-420">
                        <option data-id="element-421">Walk In</option>
                        <option data-id="element-422">Prep Station</option>
                        <option data-id="element-423">Freezer 1</option>
                        <option data-id="element-424">Liquor Room</option>
                      </select>
                    </div>
                  </div>

                  <div data-id="element-425">
                    <label className="block text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-2" data-id="element-426">
                      To Location
                    </label>
                    <div className="relative" data-id="element-427">
                      <MapPin className="absolute left-3 top-1/2 -translate-y-1/2 text-emerald-500" size={16} data-id="element-428" />
                      <select className="w-full pl-10 pr-4 py-3 bg-slate-50 border border-slate-200 rounded-xl text-sm focus:ring-2 focus:ring-emerald-500/20 outline-none transition-all" value={transferData.toLocation} onChange={e => setTransferData({
                    ...transferData,
                    toLocation: e.target.value
                  })} data-id="element-429">
                        <option data-id="element-430">Walk In</option>
                        <option data-id="element-431">Prep Station</option>
                        <option data-id="element-432">Freezer 1</option>
                        <option data-id="element-433">Liquor Room</option>
                      </select>
                    </div>
                  </div>

                  <div data-id="element-434">
                    <label className="block text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-2" data-id="element-435">
                      Quantity
                    </label>
                    <input type="number" className="w-full px-4 py-3 bg-slate-50 border border-slate-200 rounded-xl text-sm focus:ring-2 focus:ring-emerald-500/20 outline-none transition-all" value={transferData.qty} onChange={e => setTransferData({
                  ...transferData,
                  qty: Number(e.target.value)
                })} data-id="element-436" />
                  </div>

                  <div data-id="element-437">
                    <label className="block text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-2" data-id="element-438">
                      Date
                    </label>
                    <div className="relative" data-id="element-439">
                      <Calendar className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" size={16} data-id="element-440" />
                      <input type="date" className="w-full pl-10 pr-4 py-3 bg-slate-50 border border-slate-200 rounded-xl text-sm focus:ring-2 focus:ring-emerald-500/20 outline-none transition-all" value={transferData.date} onChange={e => setTransferData({
                    ...transferData,
                    date: e.target.value
                  })} data-id="element-441" />
                    </div>
                  </div>

                  <div className="md:col-span-2" data-id="element-442">
                    <label className="block text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-2" data-id="element-443">
                      Transfer Reason
                    </label>
                    <textarea rows={3} placeholder="e.g. Stocking prep station for dinner service..." className="w-full px-4 py-3 bg-slate-50 border border-slate-200 rounded-xl text-sm focus:ring-2 focus:ring-emerald-500/20 outline-none transition-all resize-none" value={transferData.reason} onChange={e => setTransferData({
                  ...transferData,
                  reason: e.target.value
                })} data-id="element-444" />
                  </div>
                </div>
              </div>

              <div className="px-8 py-6 border-t border-slate-100 bg-slate-50/50 flex items-center justify-end gap-3" data-id="element-445">
                <button onClick={() => setShowTransferModal(false)} className="px-6 py-2.5 text-sm font-bold text-slate-600 hover:bg-slate-200 rounded-xl transition-all" data-id="element-446">
                  Cancel
                </button>
                <button onClick={() => setShowTransferModal(false)} className="px-8 py-2.5 bg-emerald-500 text-white rounded-xl text-sm font-bold hover:bg-emerald-600 transition-all shadow-lg shadow-emerald-500/20" data-id="element-447">
                  Confirm Transfer
                </button>
              </div>
            </motion.div>
          </div>}
      </AnimatePresence>
    </div>;
}